import {Component, computed, input, output} from '@angular/core';
import moment from 'moment';
import {SHARED_IMPORTS} from '../../standalone-imports';

/**
 * This component allows to change the selected week.
 */
@Component({
  selector: 'app-week-select',
  templateUrl: './week-select.component.html',
  styleUrls: ['./week-select.component.less'],
  imports: [SHARED_IMPORTS]
})
export class WeekSelectComponent {

  /** The Monday, from which starts the selected week. */
  selectedMonday = input<string>('');
  /** The Monday, from which starts the last displayed week. */
  latestMonday = input<string>('');
  /** An event, which returns the selected Monday to a parent component. */
  selectedMondayEvent = output<string>();

  /** The Monday, from which starts the current week. */
  currentWeekMonday: string = moment().startOf('week').isoWeekday(1).format('YYYY-MM-DD');
  /** The Sunday, until which ends the current week. */
  currentWeekSunday: string = moment(this.currentWeekMonday).add(6, 'days').format('YYYY-MM-DD');
  /** The Monday, from which starts the next week. */
  nextWeekMonday: string = moment(this.currentWeekSunday).add(1, 'days').format('YYYY-MM-DD');
  /** Format, in which dates are displayed in HTML. */
  dateFormat = 'ddd, D MMM YYYY';

  /** The resolved latest Monday, falling back to next week Monday if not provided. */
  latestMondayInner = computed(() => this.latestMonday() || this.nextWeekMonday);

  /** The Sunday of the selected week. */
  selectedSunday = computed(() => moment(this.selectedMonday()).add(6, 'days').format('YYYY-MM-DD'));

  /**
   * Selects the previous week Monday and returns it to a parent component.
   */
  selectPreviousWeek(): void {
    const previousWeek = moment(this.selectedMonday()).subtract(7, 'days').format('YYYY-MM-DD');
    this.selectedMondayEvent.emit(previousWeek);
  }

  /**
   * Selects the next week Monday and returns it to a parent component.
   */
  selectNextWeek(): void {
    const nextWeek = moment(this.selectedMonday()).add(7, 'days').format('YYYY-MM-DD');
    this.selectedMondayEvent.emit(nextWeek);
  }
}